export const DEFAULT_BUSINESS_THEME = 'default';

export const BUSINESS_THEMES = {
  default: {
    appBg: '#ffffff',
    surfaceWarm: '#fffdfa',
    surfaceMuted: '#fcf8f4',
    surfaceSoft: '#faf7f3',
    surfaceRaised: '#ffffff',
    border: '#decebf',
    borderSoft: '#e7dbcf',
    text: '#111111',
    textStrong: '#2f2823',
    textMuted: '#8f8176',
    textSubtle: '#6f6257',
    accent: '#7c6a5a',
    accentStrong: '#6f5b48',
    accentSoft: '#e7ded5',
    accentPanel: '#ece3da',
    focus: '#b79b75',
    shadowRgb: '124,106,90',
  },
  'sea-green': {
    appBg: '#ffffff',
    surfaceWarm: '#fbfefd',
    surfaceMuted: '#eef8f4',
    surfaceSoft: '#e6f5ef',
    surfaceRaised: '#ffffff',
    border: '#bdddd2',
    borderSoft: '#d3ebe3',
    text: '#10201d',
    textStrong: '#17352f',
    textMuted: '#5d8178',
    textSubtle: '#43665e',
    accent: '#2f8f73',
    accentStrong: '#1f6f58',
    accentSoft: '#d7eee5',
    accentPanel: '#cfe8df',
    focus: '#4ca28b',
    shadowRgb: '47,143,115',
  },
  ocean: {
    appBg: '#ffffff',
    surfaceWarm: '#fbfdff',
    surfaceMuted: '#edf7fb',
    surfaceSoft: '#e4f2f7',
    surfaceRaised: '#ffffff',
    border: '#bdd7e4',
    borderSoft: '#d2e6ef',
    text: '#10212a',
    textStrong: '#173747',
    textMuted: '#5d7d8b',
    textSubtle: '#426372',
    accent: '#2d7da5',
    accentStrong: '#246988',
    accentSoft: '#d4eaf2',
    accentPanel: '#cce2ec',
    focus: '#4c92b3',
    shadowRgb: '45,125,165',
  },
  blue: {
    appBg: '#ffffff',
    surfaceWarm: '#fcfdff',
    surfaceMuted: '#f0f4fe',
    surfaceSoft: '#e9effb',
    surfaceRaised: '#ffffff',
    border: '#c8d5ed',
    borderSoft: '#dbe4f5',
    text: '#121d31',
    textStrong: '#1c3154',
    textMuted: '#657a9c',
    textSubtle: '#4c6387',
    accent: '#4d78bd',
    accentStrong: '#3d619a',
    accentSoft: '#dbe5f8',
    accentPanel: '#d2def4',
    focus: '#6388c7',
    shadowRgb: '77,120,189',
  },
  teal: {
    appBg: '#ffffff',
    surfaceWarm: '#fbfefe',
    surfaceMuted: '#ffffff',
    surfaceSoft: '#e8f6f6',
    surfaceRaised: '#ffffff',
    border: '#b8dfe0',
    borderSoft: '#d6eeee',
    text: '#061b1d',
    textStrong: '#103437',
    textMuted: '#51767a',
    textSubtle: '#315d62',
    accent: '#118a91',
    accentStrong: '#0b6f75',
    accentSoft: '#d8f0f1',
    accentPanel: '#c9e7e9',
    focus: '#118a91',
    shadowRgb: '17,138,145',
  },
  'forest-green': {
    appBg: '#ffffff',
    surfaceWarm: '#fbfdfd',
    surfaceMuted: '#ffffff',
    surfaceSoft: '#edf3f3',
    surfaceRaised: '#ffffff',
    border: '#bed0d0',
    borderSoft: '#d9e5e5',
    text: '#111f1f',
    textStrong: '#243838',
    textMuted: '#637b7b',
    textSubtle: '#4d6868',
    accent: '#719191',
    accentStrong: '#567575',
    accentSoft: '#dde8e8',
    accentPanel: '#d2e0e0',
    focus: '#719191',
    shadowRgb: '113,145,145',
  },
  obsidian: {
    appBg: '#ffffff',
    surfaceWarm: '#fcfcfc',
    surfaceMuted: '#f7f7f7',
    surfaceSoft: '#dedede',
    surfaceRaised: '#ffffff',
    border: '#9f9f9f',
    borderSoft: '#d2d2d2',
    text: '#050807',
    textStrong: '#020403',
    textMuted: '#666666',
    textSubtle: '#303030',
    accent: '#020403',
    accentStrong: '#000000',
    accentSoft: '#c7c7c7',
    accentPanel: '#020403',
    accentPanelText: '#ffffff',
    focus: '#020403',
    shadowRgb: '2,4,3',
  },
  'dark-silver': {
    appBg: '#ffffff',
    surfaceWarm: '#fbfdfd',
    surfaceMuted: '#ffffff',
    surfaceSoft: '#edf3f3',
    surfaceRaised: '#ffffff',
    border: '#bed0d0',
    borderSoft: '#d9e5e5',
    text: '#111f1f',
    textStrong: '#243838',
    textMuted: '#637b7b',
    textSubtle: '#4d6868',
    accent: '#719191',
    accentStrong: '#567575',
    accentSoft: '#dde8e8',
    accentPanel: '#d2e0e0',
    focus: '#719191',
    shadowRgb: '113,145,145',
  },
  mint: {
    appBg: '#ffffff',
    surfaceWarm: '#fcfffc',
    surfaceMuted: '#f0f8f1',
    surfaceSoft: '#ebf6ed',
    surfaceRaised: '#ffffff',
    border: '#c6dfca',
    borderSoft: '#dceee0',
    text: '#142415',
    textStrong: '#244126',
    textMuted: '#647f66',
    textSubtle: '#4e6a50',
    accent: '#63a96f',
    accentStrong: '#4e8657',
    accentSoft: '#dff0e2',
    accentPanel: '#d6ead9',
    focus: '#75b67f',
    shadowRgb: '99,169,111',
  },
  gold: {
    appBg: '#ffffff',
    surfaceWarm: '#fffdf8',
    surfaceMuted: '#fff6e6',
    surfaceSoft: '#fbf1dc',
    surfaceRaised: '#ffffff',
    border: '#ead3a5',
    borderSoft: '#f1dfba',
    text: '#2b2110',
    textStrong: '#4b3515',
    textMuted: '#8d7040',
    textSubtle: '#71582d',
    accent: '#c79334',
    accentStrong: '#956b22',
    accentSoft: '#f4e4bf',
    accentPanel: '#eedbb0',
    focus: '#d2a24d',
    shadowRgb: '199,147,52',
  },
  coral: {
    appBg: '#ffffff',
    surfaceWarm: '#fffdfc',
    surfaceMuted: '#fff1ed',
    surfaceSoft: '#faebe7',
    surfaceRaised: '#ffffff',
    border: '#ecc9c1',
    borderSoft: '#f1d9d3',
    text: '#2d1915',
    textStrong: '#51261e',
    textMuted: '#91675e',
    textSubtle: '#754f47',
    accent: '#d76f56',
    accentStrong: '#a9503d',
    accentSoft: '#f4dcd6',
    accentPanel: '#efd2ca',
    focus: '#dc826d',
    shadowRgb: '215,111,86',
  },
  rose: {
    appBg: '#ffffff',
    surfaceWarm: '#fffdfd',
    surfaceMuted: '#fff0f5',
    surfaceSoft: '#f8eaf0',
    surfaceRaised: '#ffffff',
    border: '#e8c5cf',
    borderSoft: '#f0d8df',
    text: '#2b1720',
    textStrong: '#4b2532',
    textMuted: '#8b6370',
    textSubtle: '#704c58',
    accent: '#c4657f',
    accentStrong: '#9b4f64',
    accentSoft: '#efd9e2',
    accentPanel: '#e8ced8',
    focus: '#ce7890',
    shadowRgb: '196,101,127',
  },
  lavender: {
    appBg: '#ffffff',
    surfaceWarm: '#fefcff',
    surfaceMuted: '#f4f1fd',
    surfaceSoft: '#efecfa',
    surfaceRaised: '#ffffff',
    border: '#d4cce9',
    borderSoft: '#e2dcf1',
    text: '#1d1930',
    textStrong: '#302850',
    textMuted: '#746b98',
    textSubtle: '#5e5480',
    accent: '#7b6bbb',
    accentStrong: '#62549a',
    accentSoft: '#e3def5',
    accentPanel: '#d9d2ef',
    focus: '#8b7ac5',
    shadowRgb: '123,107,187',
  },
};

function normalizeBusinessThemeName(themeName) {
  return themeName === 'dark-silver' ? 'forest-green' : themeName;
}

export function getBusinessTheme(themeName) {
  return BUSINESS_THEMES[normalizeBusinessThemeName(themeName)] || BUSINESS_THEMES[DEFAULT_BUSINESS_THEME];
}

export function getBusinessThemeName(themeName) {
  const normalizedThemeName = normalizeBusinessThemeName(themeName);
  return BUSINESS_THEMES[normalizedThemeName] ? normalizedThemeName : DEFAULT_BUSINESS_THEME;
}

export function getBusinessThemeStyle(themeName) {
  const theme = getBusinessTheme(themeName);

  return {
    '--theme-app-bg': theme.appBg,
    '--theme-surface-warm': theme.surfaceWarm,
    '--theme-surface-muted': theme.surfaceMuted,
    '--theme-surface-soft': theme.surfaceSoft,
    '--theme-surface-raised': theme.surfaceRaised,
    '--theme-border': theme.border,
    '--theme-border-soft': theme.borderSoft,
    '--theme-text': theme.text,
    '--theme-text-strong': theme.textStrong,
    '--theme-text-muted': theme.textMuted,
    '--theme-text-subtle': theme.textSubtle,
    '--theme-accent': theme.accent,
    '--theme-accent-strong': theme.accentStrong,
    '--theme-accent-soft': theme.accentSoft,
    '--theme-accent-panel': theme.accentPanel,
    '--theme-accent-panel-text': theme.accentPanelText || theme.textSubtle,
    '--theme-focus': theme.focus,
    '--theme-shadow-rgb': theme.shadowRgb,
  };
}
